import coverImg from "assets/images/v136/cover.webp"
import titleImg from "assets/images/v136/title.webp"

export const v136Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
